<template>
  <div class="legend-item">
    <component
      :class="{ 'legend-icon': icon, 'legend-emptytext': !icon }"
      :is="icon"
    ></component
    ><span>{{ desc }}</span>
  </div>
</template>
<script>
export default {
  name: 'legend-item',
  props: {
    icon: {
      type: String,
      require: true
    },
    desc: String
  }
}
</script>
<style lang="less">
.legend-item {
  display: flex;
  align-items: center;
  height: 30px;
  .legend-icon {
    width: 30px;
  }
  .legend-emptytext {
    width: 0;
  }
}
</style>
